import React from "react";
import InputFactory from "../InputFactory";

export default function CustomFormFactory({
  schema,
  onChange,
  object,
  fieldsToExlude,
  fieldToDisable,
  navigateBack,
}) {
  return (
    <>
      <div className="d-flex flex-column row gap-5">
        {schema.map((section) => {
          return (
            <div key={section.name}>
              <h5 className="fw-bold text-primary">{section.name}</h5>
              {section.name ? (
                <hr
                  className="pb-2"
                  style={{ borderTop: "1px solid rgba(0, 0, 0, .2)" }}
                />
              ) : null}
              <div className="row">
                {Object.keys(section.fields).map((key, index) => {
                  if (fieldsToExlude && fieldsToExlude.includes(key))
                    return null;

                  let disable = false;
                  let { type, _type, value, ...options } = section.fields[key];

                  if (fieldToDisable && fieldToDisable.includes(key)) {
                    if (type === "Pointer") {
                      value = object[key]?.name;
                      type = "String";
                    }
                    if (_type === "RelatedAffi") {
                      value = object[key]?.code;
                      type = "String";
                    }
                    if (type === "Relation") {
                      value = object[key][0]?.name;
                      type = "String";
                    }

                    disable = fieldToDisable.includes(key);
                  }

                  return (
                    <div
                      className={`${options.col} col-4 ${
                        index !== section.fields.length - 1 ? "mb-4" : ""
                      }`}
                      key={key}
                    >
                      <label
                        className="form-label fw-semibold"
                        style={{ fontSize: "0.875rem" }}
                      >
                        {options.label}
                        {options.required || options._required ? (
                          <span className="text-danger ms-1">*</span>
                        ) : null}
                      </label>
                      <InputFactory
                        field={key}
                        key={key}
                        object={object}
                        type={type}
                        {...(disable ? { value } : {})}
                        disabled={disable}
                        onChange={onChange}
                        {...options}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
      <div className="d-flex gap-3 w-100 justify-content-center mt-5">
        <button
          type="button"
          style={{ width: "8rem" }}
          className="btn btn-light"
          onClick={navigateBack}
        >
          Cancel
        </button>
        <button style={{ width: "8rem" }} className="btn btn-primary">
          Save
        </button>
      </div>
    </>
  );
}
